import { BaseIcon } from './BaseIcon';
import { ReactComponent as svg } from './svgIcons/check.svg';

export const CheckIcon = ({ ...props }) => <BaseIcon svg={svg} {...props} />;
